import {Form, Input, Select} from "antd";

import "./Filters.css"
import {useEffect, useRef, useState} from "react";
import {AdminHttpService} from "../../../../services/Http/SearchTableService";
import {NotificationService} from "../../../../services/NotificationService";

export interface FilterSelectSelectOption {
    value: string | number;
    label: string;
}
export interface FilterSelectProps{
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    options?:FilterSelectSelectOption[];
    api?:{
        url:string,
        method?:"POST"|"GET",
        value:string,
        label:string,
        sendAsObject:boolean,
        searchEnabled?:boolean,
        responseKey?:string,
    };
    showSearch?:boolean;
}

export function FilterSelect<T extends Record<string, any>>(props:FilterSelectProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]
    const [fetchedOptions, setFetchedOptions] = useState<FilterSelectSelectOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);


    async function fetchOptions(url: string, valueKey: string, labelKey: string, responseKey:string="data",method:"POST"|"GET"= "GET", searchValue?:string) {
        try {
            let criteria:any = {
                unpaged: true
            };
            if(searchValue)
                criteria[labelKey] = searchValue;

            let response;
            if(method === "GET"){
                response = await AdminHttpService.get<T>(url, criteria);
            }else{
                response = await AdminHttpService.getWithPostMethod<T>(url, criteria);
            }

            const options = response.data[responseKey].map((item: T) => {
                return {value: item[valueKey], label: item[labelKey]}
            })
            setFetchedOptions(options)
        } catch (e) {
            console.log(e);
            NotificationService.getInstance().openNotificationError("Impossibile caricare il dati")
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!props.options && props.api) {
            fetchOptions(props.api.url,props.api.value,props.api.label, props.api.responseKey,props.api.method);
        }
    }, [props.options, props.api]);

    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    const finalOptions = props.options || fetchedOptions;

    function onChange(value:any){
        if(props?.onChange){
            props?.onChange(value.target.value)
        }
    }

    const filterOption = (input: string, option?: FilterSelectSelectOption) => {

        return (
            option?.label
                .toLowerCase()
                .includes(input.toLowerCase()) ?? false
        );
    };

    const transformValueToObject = (value: string | number) => {
        if (value === null || value === undefined) {
            return null;
        }
        if(props.api && props.api.sendAsObject)
            return {[props.api?.value]: value};
        else
            return value;
    };

    const transformObjectToValueProps = (value: any) => {
        if (value && props.api && props.api.sendAsObject) {
            return { value: value[props.api.value] };
        }
        return { value: value };
    };

    const handleSearch = (value: string) => {
        if (props.api && props.api.searchEnabled) {
            setLoading(true)

            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
            searchTimeoutRef.current = setTimeout(() => {
                fetchOptions(props.api!.url, props.api!.value, props.api!.label, props.api!.responseKey,props.api!.method, value);
            }, 500);
        }
    }

    const className = "filter " + (props?.className ?? "");

    return  <>
        <Form.Item name={props.dataKey}
                   label={props.label}
                   rules={rules}
                   getValueFromEvent={(value) => transformValueToObject(value)}
                   getValueProps={(value) => transformObjectToValueProps(value)}
        >
            <Select className={className}
                    placeholder={props.placeholder}
                    onChange={onChange}
                    allowClear={true}
                    options={finalOptions}
                    showSearch={props.showSearch}
                    filterOption={filterOption}
                    onSearch={handleSearch}
                    loading={loading}
            >
            </Select>
        </Form.Item>

    </>

}